interface ToggleSwitchProps {
  enabled: boolean;
  disabled?: boolean;
}

export function ToggleSwitch({ enabled, disabled = false }: ToggleSwitchProps) {
  return (
    <div
      className={`w-12 h-7 rounded-full transition-colors relative ${
        enabled ? "bg-primary" : "bg-secondary"
      } ${disabled ? "opacity-45" : ""}`}
      aria-hidden="true"
    >
      <div
        className={`absolute top-1 w-5 h-5 bg-white rounded-full transition-transform ${
          enabled ? "translate-x-6" : "translate-x-1"
        }`}
      />
    </div>
  );
}